import { AccessLevel } from '../../../types';
import { CreateBroadcastActionPayload } from '../types';

const normalizeString = (value: unknown) => (typeof value === 'string' ? value : undefined);

const normalizeAccessLevel = (value: unknown) => {
    if (value === AccessLevel.PUBLIC || value === AccessLevel.ORGANIZATION) {
        return value;
    }

    return undefined;
};

const isRecord = (value: unknown): value is Record<string, unknown> =>
    typeof value === 'object' && value !== null && !Array.isArray(value);

export const normalizeCreateBroadcastPayload = (payload: unknown): CreateBroadcastActionPayload => {
    if (!isRecord(payload)) {
        return {};
    }

    return {
        caption: normalizeString(payload.caption),
        description: normalizeString(payload.description),
        accessLevel: normalizeAccessLevel(payload.accessLevel),
    };
};
